import commonService from './common-service';

class FlowRackInventory {
  async getDefaults() {
    try {
      const response = await commonService.getFromServer('FlowRack/Defaults', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getDrugName(value) {
    try {
      const response = await commonService.getFromServer('FlowRack/GetDrugByUPC?upc=' + value, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async postdata(params) {
    try {
      const response = await commonService.postToServer('FlowRack/SubmitCardQuantity', params);
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      const error = new Error(e);
      error.code = e.code;
      error.msg = e.msg;
      throw error;
    }
  }

}

export default new FlowRackInventory();
